import { useState } from 'react';
import { Bell, BellOff, Share, Plus, X } from 'lucide-react';
import { ehApple } from './push';
import type { Avisos } from './useAvisos';

// A faixa que CONVIDA a ligar os avisos (DA-532, redesenhada na DA-534).
//
// ⚠️ **Ela so aparece pra quem ainda NAO ligou.** O estado "ligado" saiu daqui em
// 14/08/2026: uma faixa permanente dizendo "esta tudo certo" e' ruido puro —
// repete a cada abertura uma informacao que a pessoa entendeu na primeira vez, e
// come uma linha inteira de uma tela de celular. Quem esta ligado ve o chat; o
// liga/desliga mora no menu (pedido dele: *"um menu de 3 tracinho... e dentro
// Config... a opcao de desmarcar aviso de mensagens"*).
//
// ⚠️ **O convite tem DOIS textos, nao um.** No Android o aviso funciona em aba
// comum e o caminho e' um toque; no iPhone a Apple so entrega push pra site
// adicionado a TELA DE INICIO, entao la o primeiro passo nao e' nosso — e' um
// passo a passo. Dizer "seu aparelho nao suporta" pro iPhone seria mentira: ele
// suporta, so exige o atalho antes.
//
// ⛔ O texto NAO promete tempo de resposta. Ele promete que a mensagem CHEGA
// ([DA-523]) — promessa quebrada aqui queima mais rapido que no WhatsApp, porque a
// marca na tela e' a da loja.

const COBRE = '#b45309';
const CHAVE_ADIADO = 'fiodecobre.app.avisos.adiado';

export function AvisosPush({ avisos }: { avisos: Avisos }): React.ReactElement | null {
  const { situacao, ocupado, erro, detalhe, ligar } = avisos;
  const [adiado, setAdiado] = useState(() => localStorage.getItem(CHAVE_ADIADO) === '1');

  function adiar(): void {
    localStorage.setItem(CHAVE_ADIADO, '1');
    setAdiado(true);
  }

  // Ligado, apurando ou sem caminho: a faixa nao tem o que dizer. E quem ja
  // dispensou uma vez nao e' perguntado de novo a cada abertura.
  if (situacao === 'apurando' || situacao === 'indisponivel' || situacao === 'ligado') return null;
  if (adiado) return null;

  if (situacao === 'bloqueado') {
    return (
      <div style={{ padding: '10px 14px', backgroundColor: '#fff7ed', borderBottom: '1px solid #fed7aa', fontSize: 12.5, color: '#431407', lineHeight: 1.5 }}>
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: 8 }}>
          <BellOff size={15} style={{ color: COBRE, flexShrink: 0, marginTop: 1 }} />
          <div style={{ flex: 1 }}>
            <strong>Os avisos estao bloqueados neste aparelho.</strong>
            {/* ⚠️ "Abra as configuracoes do navegador" nao e' instrucao, e' um encaminhamento —
                quem esta travado precisa saber ONDE tocar. Sao dois caminhos diferentes: no
                Android o bloqueio e' do SITE (some pelo cadeado da barra de endereco); no iPhone
                o app ja esta na tela de inicio, entao quem manda e' o ajuste do proprio aparelho.
                ⛔ Sem nomear o rotulo exato de cada menu: ele muda de versao pra versao, e
                instrucao com nome errado e' pior que instrucao generica. */}
            {ehApple() ? (
              <div style={{ marginTop: 3 }}>
                Abra os <strong>Ajustes</strong> do iPhone, entre em <strong>Notificacoes</strong>,
                procure <strong>AppCel</strong> na lista e permita os avisos. Depois volte aqui.
              </div>
            ) : (
              <div style={{ marginTop: 3 }}>
                Toque no <strong>cadeado</strong> ao lado do endereco, no alto da tela, procure
                <strong> Notificacoes</strong> e mude para <strong>Permitir</strong>. Depois recarregue
                esta pagina.
              </div>
            )}
          </div>
          <button type="button" onClick={adiar} aria-label="Agora nao" style={{ color: '#9a3412', flexShrink: 0 }}>
            <X size={16} />
          </button>
        </div>
      </div>
    );
  }

  if (situacao === 'ensinar-iphone') {
    return (
      <div style={{ padding: '11px 14px', backgroundColor: '#fff7ed', borderBottom: '1px solid #fed7aa', fontSize: 13, color: '#431407', lineHeight: 1.55 }}>
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: 8 }}>
          <Bell size={16} style={{ color: COBRE, flexShrink: 0, marginTop: 2 }} />
          <div style={{ flex: 1 }}>
            <strong>Quer ser avisado quando a loja responder?</strong>
            <div style={{ marginTop: 5 }}>
              No iPhone, os avisos so funcionam com o atalho na tela de inicio. Sao dois toques:
            </div>
            <ol style={{ margin: '7px 0 0 0', paddingLeft: 18 }}>
              <li style={{ marginBottom: 3 }}>
                Toque em <Share size={13} style={{ verticalAlign: -2 }} /> <strong>Compartilhar</strong>, na barra do Safari.
              </li>
              <li>
                Escolha <Plus size={13} style={{ verticalAlign: -2 }} /> <strong>Adicionar a Tela de Inicio</strong>.
              </li>
            </ol>
            <div style={{ marginTop: 7, fontSize: 12.5, opacity: 0.85 }}>
              Depois abra o AppCel por esse atalho — o botao de ligar os avisos aparece aqui.
            </div>
          </div>
          <button type="button" onClick={adiar} aria-label="Agora nao" style={{ color: '#9a3412', flexShrink: 0 }}>
            <X size={16} />
          </button>
        </div>
      </div>
    );
  }

  // 'oferecer'
  return (
    <div style={{ padding: '10px 14px', backgroundColor: '#fff7ed', borderBottom: '1px solid #fed7aa', fontSize: 13, color: '#431407' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        <Bell size={16} style={{ color: COBRE, flexShrink: 0 }} />
        <div style={{ flex: 1, lineHeight: 1.45 }}>
          <strong>Seja avisado quando a loja responder.</strong>
          <div style={{ fontSize: 12.5, opacity: 0.85 }}>Sem precisar ficar abrindo esta tela.</div>
        </div>
        <button type="button" onClick={adiar} aria-label="Agora nao" style={{ color: '#9a3412', flexShrink: 0 }}>
          <X size={16} />
        </button>
      </div>
      <button
        type="button"
        onClick={() => void ligar()}
        disabled={ocupado}
        style={{
          marginTop: 9, width: '100%', padding: '9px 12px', borderRadius: 9,
          backgroundColor: COBRE, color: '#fff', fontWeight: 700, fontSize: 13.5,
          opacity: ocupado ? 0.6 : 1,
        }}
      >
        {ocupado ? 'Ligando...' : 'Ativar avisos'}
      </button>
      {erro && <div style={{ marginTop: 7, fontSize: 12.5, color: '#b91c1c' }}>{erro}</div>}
      {/* A medicao crua, em letra miuda. Nao e' pro cliente entender — e' pra ela caber
          no print que ele manda quando diz "nao funcionou". Sem isso, o que chega e' a
          frase amigavel, que e' justamente a que nao distingue as causas. */}
      {detalhe && (
        <div style={{ marginTop: 4, fontSize: 10.5, color: '#78716c', fontFamily: 'monospace' }}>
          {detalhe}
        </div>
      )}
      {/* ⚠️ Quem dispensar aqui nao fica sem caminho: o liga/desliga continua no
          menu → Configuracoes. Faixa dispensada nao pode virar recurso perdido. */}
      <div style={{ marginTop: 7, fontSize: 12, opacity: 0.75 }}>
        Voce pode ligar depois no menu ☰ → Configuracoes.
      </div>
    </div>
  );
}
